import React, { createContext, useState, useCallback } from 'react';

const ChatUserContext = createContext();

export const ChatUserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({
    email: '',
    cellNumber: '',
    medicalAidNumber: '',
  });

  const updateUserInfo = useCallback((updates) => {
    setUserInfo((prev) => ({ ...prev, ...updates }));
  }, []);

  const clearUserInfo = useCallback(() => {
    setUserInfo({ email: '', cellNumber: '', medicalAidNumber: '' });
  }, []);

  return (
    <ChatUserContext.Provider value={{ userInfo, updateUserInfo, clearUserInfo }}>
      {children}
    </ChatUserContext.Provider>
  );
};

export default ChatUserContext;
